import { GridColumn, GridRow } from "../grid/Grid";
import { Button } from "../button/Button";
import { Label } from "../label/Label";
import './ExceptionPage.scss';
function ExceptionPage(props: {title: string, subTitle?: string, description: string, showHomebutton?: boolean}) {

    const onClickOK = () => {
        localStorage.clear();
        const originURL = window.location.origin;
        window.location.href = originURL;
    }

    return (
        <GridRow className="h-100">    
            <GridColumn className="p-0" columns={12}>
                <div className="excp-wrapper">
                    <div className="excp-title text-medium">{props.title}</div>
                    {props.subTitle && <h3 className="excp-sub-title">{props.subTitle}</h3>}
                    <Label className="excp-description">{props.description}</Label>
                    {props.showHomebutton && <Button fillType="primary" color="blue" className="excp-button" onClick={onClickOK}>{props.title === '400' ? 'Try again.' : 'Go Home'}</Button> }
                </div>
            </GridColumn>
        </GridRow>
    );
}

export default ExceptionPage;